@let configFilter = config$ | async;

<div class="absolute right-13 top-5 flex justify-end gap-2">
  @for (option of options; track option.value) {
    <button
      app-flat-button
      type="button"
      (click)="onSetActive(option.value)"
      class="rounded-full! flex p-2.5! size-12 transition duration-300 border border-solid border-base-gray-light-500 text-base-status-info-500 bg-white hover:bg-base-status-info! hover:text-white! shadow!"
      [ngClass]="{ 'bg-base-status-info! text-white! border-base-status-info': option.value === currentOption() }"
    >
      <svg-icon class="flex items-center justify-center w-full h-full" [src]="option.icon | icon"></svg-icon>
    </button>
  }
</div>

<form
  [formGroup]="form"
  class="flex relative gap-4 flex-col justify-between @container lg:mt-2 mb-5 pt-4 bg-white min-h-20 rounded-2xl shadow-mobile-submenu-inner-default w-full"
>
  <div
    class="absolute shadow-arrow-up -top-3 rotate-45 size-7 bg-white"
    [ngClass]="{
      'right-36': isShortcutActive,
      'right-22': isCalendarActive,
      'right-8': isExtraActive,
    }"
  ></div>

  <div class="flex relative justify-between">
    @if (isShortcutActive || isCalendarActive) {
      <div class="w-full @large:w-1/3 relative px-4 flex items-center">
        <!-- Shorcut -->
        @if (isShortcutActive) {
          <div class="flex gap-1">
            @for (option of shortcuts; track option) {
              <button
                (click)="onShortcut(option.value)"
                type="button"
                app-button
                class="rounded-full! border border-solid border-base-gray-light-500 px-5! text-title shadow! text-md font-medium whitespace-nowrap hover:bg-base-status-info hover:text-white transition duration-300"
                [ngClass]="{
                  'bg-base-status-info border-base-status-info text-white': isEqual(option.value, configFilter?.filter),
                }"
                translate
              >
                {{ option.label }}
              </button>
            }
          </div>
        } @else {
          <!-- Calendar -->
          <div class="flex gap-2 w-full items-center max-w-110">
            <span class="w-10" translate> eclass.agenda.filtros.de </span>
            <app-input-datepicker
              formControlName="date_min"
              [strategy]="[strategy.BOTTOM]"
              [minDate]="configFilter?.period?.start"
              [maxDate]="form.value.date_max"
              custom="rounded-xl!"
              [clearable]="false"
              class="w-full"
            />

            <span class="w-10" translate> eclass.agenda.filtros.ate </span>
            <app-input-datepicker
              formControlName="date_max"
              [strategy]="[strategy.BOTTOM]"
              [minDate]="form.value.date_min"
              [maxDate]="configFilter?.period?.end"
              custom="rounded-xl!"
              [clearable]="false"
              class="w-full"
            />
          </div>
        }
        <hr class="absolute hidden @post:block right-0 w-px h-[calc(100%+25px)] bg-theme-100 top-[-13px]" />
      </div>
    }

    @if (configFilter?.filters) {
      <div
        class="hidden w-full px-4 @post:grid grid-cols-1 @large:grid-auto-fit-[20rem] 2xl:grid-auto-fit-[30rem]! items-center gap-2"
        [ngClass]="{
          '@large:w-2/3': isShortcutActive || isCalendarActive,
          'grid!': isExtraActive,
        }"
      >
        @if (showField(filterControl.Level, configFilter.filters)) {
          <ng-select
            app-select
            [placeholder]="'geral.selecionar-nivel' | translate"
            [formControlName]="filterControl.Level"
            [loading]="level.load()"
            [items]="level.data()"
            bindLabel="descricao"
            bindValue="id"
            class="w-full ng-select-float"
            [notFoundText]="'geral.nao-encontrado' | translate"
            [loadingText]="'geral.carregando' | translate"
          >
          </ng-select>
        }

        @if (showField(filterControl.Grade, configFilter.filters)) {
          <ng-select
            app-select
            [placeholder]="'geral.selecionar-serie' | translate"
            [formControlName]="filterControl.Grade"
            [loading]="grade.load()"
            [items]="grade.data()"
            bindLabel="name"
            bindValue="id"
            class="w-full ng-select-float"
            [notFoundText]="'geral.nao-encontrado' | translate"
            [loadingText]="'geral.carregando' | translate"
            groupBy="level"
          >
          </ng-select>
        }

        @if (showField(filterControl.Group, configFilter.filters)) {
          <ng-select
            app-select
            [placeholder]="'geral.selecionar-turma' | translate"
            [formControlName]="filterControl.Group"
            [loading]="group.load()"
            [items]="group.data()"
            bindLabel="name"
            bindValue="id"
            class="w-full ng-select-float"
            [notFoundText]="'geral.nao-encontrado' | translate"
            [loadingText]="'geral.carregando' | translate"
            groupBy="default_grade"
          >
          </ng-select>
        }

        @if (showField(filterControl.Subject, configFilter.filters)) {
          <ng-select
            app-select
            [placeholder]="'geral.selecionar-disciplina' | translate"
            [formControlName]="filterControl.Subject"
            [loading]="subject.load()"
            [items]="subject.data()"
            [compareWith]="compareSubjects"
            bindLabel="name"
            bindValue="ids"
            class="w-full ng-select-float"
            [notFoundText]="'geral.nao-encontrado' | translate"
            [loadingText]="'geral.carregando' | translate"
          >
          </ng-select>
        }

        @if (showField(filterControl.UserGroup, configFilter.filters)) {
          <ng-select
            app-select
            [placeholder]="'geral.selecionar-grupo' | translate"
            [formControlName]="filterControl.UserGroup"
            [items]="userGroups.data()"
            [loading]="userGroups.load()"
            bindLabel="descricao"
            bindValue="id"
            class="w-full ng-select-float"
            [notFoundText]="'geral.nao-encontrado' | translate"
            [loadingText]="'geral.carregando' | translate"
          >
          </ng-select>
        }

        @if (showField(filterControl.Author, configFilter.filters)) {
          <ng-select
            app-select
            [placeholder]="'geral.selecionar-professor' | translate"
            [formControlName]="filterControl.Author"
            [loading]="teacher.load()"
            [items]="teacher.data()"
            bindLabel="nome"
            bindValue="user_id"
            class="w-full ng-select-float"
            [notFoundText]="'geral.nao-encontrado' | translate"
            [loadingText]="'geral.carregando' | translate"
          >
          </ng-select>
        }

        @if (showField(filterControl.Generic, configFilter.filters)) {
          <ng-select
            app-select
            [placeholder]="'geral.selecionar-status' | translate"
            [formControlName]="filterControl.Generic"
            class="w-full ng-select-float"
            [searchable]="false"
            [clearable]="false"
          >
            @for (status of configFilter.status; track $index) {
              <ng-option [value]="status.key">
                {{ status.description | translate }}
              </ng-option>
            }
          </ng-select>
        }
      </div>
    }
  </div>
  @if (badgets() | noEmpty) {
    <app-horizontal-scroll class="border-t border-colid border-theme-100">
      <div class="px-4 flex gap-2 w-full py-4">
        @for (item of badgets(); track $index) {
          <div class="rounded-full text-white bg-base-status-info-400 inline-flex gap-1 items-center px-2 w-max">
            <span class="text-base whitespace-nowrap cursor-pointer" (click)="item.active()">
              {{ item.label }}
            </span>
            @if (item.clear) {
              <svg-icon
                class="border-l border-solid border-whiteflex items-center size-5 cursor-pointer"
                [src]="'icon-close' | icon"
                (click)="item.clear()"
              ></svg-icon>
            }
          </div>
        }
      </div>
    </app-horizontal-scroll>
  }
</form>
